<template>
  <div class="p-4 bg-white-100 text-xs hover:bg-blue-50 group border-l-4 border-blue-500">
    <div class="flex justify-between">
      <div>
        <span class="text-gray-600">From: </span>
        <span class="text-gray-700 font-medium">{{ fromAddress }}</span>
      </div>
      <div>
        <span>
          {{ sentAt }}
        </span>
      </div>
    </div>
    <div class="flex justify-between mt-2">
      <div>
        <span class="text-gray-600">Subject: </span>
        <span class="text-gray-700 font-medium">{{ emailMessage.subject || 'N/A' }}</span>
      </div>
    </div>
    <ul v-if="hasActions" class="gap-1 flex mt-4">
      <li v-if="can.edit">
        <BaseButton small secondary @click="handleEdit"> Edit </BaseButton>
      </li>
      <li v-if="can.destroy">
        <BaseButton small secondary @click="handleDelete"> Delete </BaseButton>
      </li>
    </ul>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    emailMessage: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isSent() {
      return typeof this.emailMessage.sent_at === 'string';
    },
    sentAt() {
      return moment.utc(this.emailMessage.sent_at).local().format('DD/MM/YYYY HH:mm');
    },
    sentAtFromNow() {
      return moment.utc(this.emailMessage.sent_at).local().fromNow();
    },
    lastSentAtDate() {
      if (!this.isSent) {
        return '';
      }

      return moment;
    },
    fromAddress() {
      return this.emailMessage?.third_party_service?.config?.from_email || 'N/A';
    },
    can() {
      return {
        view: true,
        edit: !this.isSent && this.emailMessage.user_id === this.$user.id,
        destroy: !this.isSent && this.emailMessage.user_id === this.$user.id,
      };
    },
    hasActions() {
      return Object.keys(this.can).some((action) => this.can[action]);
    },
  },
  methods: {
    handleEdit() {
      this.$emit('edit', this.emailMessage);
    },
    handleView() {
      this.$emit('view', this.emailMessage);
    },
    handleDelete() {
      this.$emit('delete', this.emailMessage);
    },
  },
};
</script>
